
import { useState, useCallback } from 'react';

export const useSidebarState = () => {
  // Initialize with the first section expanded by default
  const [expandedItems, setExpandedItems] = useState<{[key: string]: boolean}>({
    'section0': true
  });

  const toggleItem = useCallback((key: string) => {
    setExpandedItems(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  }, []);

  // Add a new method to specifically set an item's expanded state without toggling
  const setItemExpanded = useCallback((key: string, isExpanded: boolean) => {
    setExpandedItems(prev => ({
      ...prev,
      [key]: isExpanded
    }));
  }, []);

  return {
    expandedItems,
    toggleItem,
    setItemExpanded
  };
};
